import Vue from 'vue'
//import {_} from "vue-underscore";
//import i18n from "../translation";

const arraySmallerThan = (val, compare) => {
    for (let i = 0; i < val.length; i++) {
        if (val[i] >= compare[i]) {
            return false;
        }
    }
    return true;
}

/**
 * @params val - the original value
 * @params compare - the compare value
 * @params modifier - eq, lt, gt or contains
 * the sentence is in the form of: "val lt compare"
 * */
const filterMethod = (val, modifier, compare) => {
    if (!val || !modifier || !compare) {
        return false;
    }
    let s, t;
    const rgx = /[[0-9.]*,[0-9.]*,[[0-9.]+]/g;
    let isArray = val.match(rgx);
    if (isArray && modifier !== 'eq') {
        s = JSON.parse(val);
        t = JSON.parse(compare);
    } else if (isArray) {
        s = JSON.stringify(val);
        t = JSON.stringify(compare);
    } else if (['lt', 'gt'].includes(modifier)) {
        s = parseFloat(val);
        t = parseFloat(compare);
    } else {
        s = val.toLowerCase();
        t = compare.toLowerCase();
    }
    switch (modifier) {
        case 'eq':
            return s == t; // only two because we want to check numbers as well
        case 'lt':
            return isArray ? arraySmallerThan(t, s) : s > t;
        case 'gt':
            return isArray ? arraySmallerThan(s, t) : s < t;
        case 'contains':
            return !!s.includes(t);
        case 'like':
            return !!s.includes(t);
    }
}

const state = {
    exportProfiles: {},
};

const getters = {
    /*getExportProfiles() {
        return state.exportProfiles.textList;
    },*/
    getExportProfilesById: (state) => (id) => {
        return state.exportProfiles[id] ? state.exportProfiles[id] : {};
    },
    getMergeById: (state) => (id) => {
        return state.exportProfiles[id] && state.exportProfiles[id].merge ? state.exportProfiles[id].merge : [];
    },
    getExportFilterById: (state) => (id) => {
        return state.exportProfiles[id] && state.exportProfiles[id].filter ? state.exportProfiles[id].filter : [];
    },
    getExportFilterStringById: (state) => (id) => {
        return state.exportProfiles[id] && state.exportProfiles[id].filterStringArray ? state.exportProfiles[id].filterStringArray : [];
    },
    getExportMergeStringById: (state) => (id) => {
        return state.exportProfiles[id] && state.exportProfiles[id].mergeStringArray ? state.exportProfiles[id].mergeStringArray : [];
    },
    getExportFilterModeById: (state) => (id) => {
        return state.exportProfiles[id] && state.exportProfiles[id].pipeline && state.exportProfiles[id].pipeline.subVersion ? state.exportProfiles[id].pipeline.subVersion.mode : 'exclude';
    },
    getExportFilterIdArrayById: (state) => (id) => {
        return state.exportProfiles[id] && state.exportProfiles[id].filterIdArray ? state.exportProfiles[id].filterIdArray : [];
    },
    getExportMergeIdArrayById: (state) => (id) => {
        return state.exportProfiles[id] && state.exportProfiles[id].mergeIdArray ? state.exportProfiles[id].mergeIdArray : [];
    },
    getAssemblyItemsInstancesFiltered: (state) => (args) => {
        const {filterType, filterId, asKeys, instances} = args;
        const id = filterId;
        const stringFilterMode = 'OR';
        let stringFilter = [];
        if(filterType === 'Filter') {
            stringFilter = state.exportProfiles[id] && state.exportProfiles[id].filterStringArray ? state.exportProfiles[id].filterStringArray : [];
        } else {
            stringFilter = state.exportProfiles[id] && state.exportProfiles[id].mergeStringArray ? state.exportProfiles[id].mergeStringArray : [];
        }

        let metaFilter = [];
        if(filterType === 'Filter') {
            metaFilter = state.exportProfiles[id] && state.exportProfiles[id].filter ? state.exportProfiles[id].filter : [];
        } else {
            metaFilter = state.exportProfiles[id] && state.exportProfiles[id].merge ? state.exportProfiles[id].merge : [];
        }

        let instanceIds = [];
        if(filterType === 'Filter') {
            instanceIds = state.exportProfiles[id] && state.exportProfiles[id].filterIdArray ? state.exportProfiles[id].filterIdArray : [];
        } else {
            instanceIds = state.exportProfiles[id] && state.exportProfiles[id].mergeIdArray ? state.exportProfiles[id].mergeIdArray : [];
        }

        console.log('got args', args);
        console.log('stringFilter', stringFilter);
        console.log('metaFilter', metaFilter);
        console.log('instanceIds', instanceIds);
        const lists = instances; //rootState.AssemblyItemsInstanceLists[listName];
        if (lists) {
            let items = lists;
            if (!stringFilter.length && !metaFilter.length && (!instanceIds || !instanceIds.length)) {
                return [];
            }
            let result = [];
            if(instanceIds && instanceIds.length) {
                const instanceIdResult = JSON.parse(JSON.stringify(items)).filter(item => {
                    return instanceIds.includes(item.id)
                })
                result = instanceIdResult;
            }
            if (stringFilter && stringFilter.length) {
                const stringFilterResult = JSON.parse(JSON.stringify(items)).filter(item => {
                    const length = stringFilter.filter(filter => {
                        const {field, modifier, val} = filter;
                        return filterMethod(item[field], modifier, val);
                    }).length;
                    return stringFilterMode === 'AND' ? length === stringFilter.length : length !== 0;
                });
                result = [...new Set([...result, ...stringFilterResult])];
            }
            if (metaFilter && metaFilter.length) {
                const metaFilterResult = JSON.parse(JSON.stringify(items)).filter(item => {
                    const itemMetaSets = item.squashedMetaFields;
                    if (!itemMetaSets) {
                        return false;
                    }
                    const metaValuesOnly = itemMetaSets.map(item => {
                        return item.squashedMetaValues
                    });
                    if (metaValuesOnly) {
                        return metaFilter.filter(filter => {
                            const {metaSet, metaField, modifier, val} = filter;
                            const targetFields = metaValuesOnly.filter(item => {
                                return item.metaSetName === metaSet && item.metaFieldKey === metaField
                            })
                            if (!targetFields.length) {
                                return false;
                            }
                            const finalValue = targetFields[0].finalMetaValue;
                            return filterMethod(val, modifier, finalValue);
                        }).length === metaFilter.length;
                    }
                })
                result = [...new Set([...result, ...metaFilterResult])];
            }
            if (result.length) {
                if (asKeys) {
                    return result.map(item => {
                        return item.id
                    });
                }
                return result;
            }
        }
        return [];
    }
};

const mutations = {
    importExportProfileMutation(state, data) {
        const {id, value} = data;

        if (state.exportProfiles[id]) {
            Vue.delete(state.exportProfiles, id);
        }
        Vue.set(state.exportProfiles, id, value);
    },
    overwritePropertyMutation(state, data) {
        const {property, id, value} = data;
        if (!state.exportProfiles[data.id]) {
            return;
        }
        Vue.set(state.exportProfiles[id], property, value);
    },
    overwriteModeMutation(state, data) {
        const {id, value} = data;
        if (!state.exportProfiles[data.id]) {
            return;
        }
        if (!state.exportProfiles[id].pipeline) {
            Vue.set(state.exportProfiles[id], "pipeline", {});
        }
        if (!state.exportProfiles[id].pipeline.subVersion) {
            Vue.set(state.exportProfiles[id].pipeline, "subVersion", {});
        }
        Vue.set(state.exportProfiles[id].pipeline.subVersion, "mode", value);
    }
};

const actions = {
    importProfile({commit}, args = {}) {
        const {id, value} = args;
        if (!value.filter) {
            value.filter = [];
        }
        if (!value.merge) {
            value.merge = [];
        }
        if (!value.filterStringArray) {
            value.filterStringArray = [];
        }
        if (!value.mergeStringArray) {
            value.mergeStringArray = [];
        }
        if (!value.filterIdArray) {
            value.filterIdArray = [];
        }
        if (!value.mergeIdArray) {
            value.mergeIdArray = [];
        }
        commit('importExportProfileMutation', {id, value});
    },
    overwriteFilter({commit}, args = {}) {
        const {id, value} = args;
        commit('overwritePropertyMutation', {id, value, property: 'filter'});
    },
    overWriteMerge({commit}, args = {}) {
        const {id, value} = args;
        commit('overwritePropertyMutation', {id, value, property: 'merge'});
    },
    overWriteFilterStringArray({commit}, args = {}) {
        const {id, value} = args;
        commit('overwritePropertyMutation', {id, value, property: 'filterStringArray'});
    },
    overWriteMergeStringArray({commit}, args = {}) {
        const {id, value} = args;
        commit('overwritePropertyMutation', {id, value, property: 'mergeStringArray'});
    },
    overWriteFilterIdArray({commit}, args = {}) {
        const {id, value} = args;
        commit('overwritePropertyMutation', {id, value, property: 'filterIdArray'});
    },
    overWriteMergeIdArray({commit}, args = {}) {
        const {id, value} = args;
        commit('overwritePropertyMutation', {id, value, property: 'mergeIdArray'});
    },
    overWriteFilterMode({commit}, args = {}) {
        const {id, value} = args;
        commit('overwriteModeMutation', {id, value});
    },
};
export default {
    state, getters, mutations, actions
}
